module.exports = __webpack_public_path__ + "img/footer1.675c18c8.png";